var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8682_10949)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83841 1.74779C11.0575 0.52873 13.034 0.52873 14.253 1.74779C15.4721 2.96686 15.4721 4.94335 14.253 6.16242L7.9295 12.486C7.56822 12.8473 7.35555 13.0599 7.11895 13.2445C6.84009 13.462 6.53835 13.6485 6.21909 13.8006C5.94823 13.9297 5.66288 14.0248 5.17814 14.1864L2.95739 14.9266L2.42267 15.1049C1.98896 15.2494 1.5108 15.1366 1.18753 14.8133C0.864265 14.49 0.751386 14.0119 0.895955 13.5782L1.81444 10.8227C1.976 10.338 2.07111 10.0526 2.2002 9.78174C2.35235 9.46248 2.53883 9.16074 2.75634 8.88188C2.94088 8.64528 3.15358 8.4326 3.5149 8.07131L9.83841 1.74779ZM2.93432 13.8802L4.82867 13.2488C5.35608 13.073 5.58017 12.9974 5.78887 12.8979C6.04257 12.777 6.28233 12.6288 6.50393 12.456C6.68623 12.3138 6.85407 12.1472 7.24718 11.7541L12.2935 6.70774C11.7677 6.5223 11.0904 6.17858 10.4563 5.5445C9.82225 4.91042 9.47852 4.23309 9.29309 3.70733L4.24677 8.75365C3.85366 9.14676 3.68704 9.31459 3.54485 9.4969C3.37201 9.71849 3.22383 9.95826 3.10292 10.212C3.00346 10.4207 2.92785 10.6447 2.75205 11.1722L2.1206 13.0665L2.93432 13.8802ZM10.1042 2.89619C10.127 3.01283 10.1656 3.17139 10.2299 3.35675C10.3746 3.77405 10.6481 4.32208 11.1634 4.83739C11.6787 5.3527 12.2268 5.62619 12.6441 5.77096C12.8294 5.83527 12.988 5.8738 13.1046 5.8966L13.5459 5.45531C14.3745 4.62677 14.3745 3.28344 13.5459 2.4549C12.7174 1.62636 11.3741 1.62636 10.5455 2.4549L10.1042 2.89619Z",
    fill: "#0D0D0D",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8682_10949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.016f98beb33a9ce12d2c2cf74967b82e.svg";
export { ForwardRef as ReactComponent };